<template>
  <v-card flat class="rounded-xl" color="background">
    <v-card-title>{{ gate.name }}</v-card-title>
    <v-card-text>
      <div>
        Lokáció: {{ building?.name }} - {{ buildingLevel?.name }}
      </div>
      <div>
        Kiegészítő eszköz: {{ gate.additional.selected ? 'Igen' : 'Nem' }}
      </div>
      <div v-if="gate.name_addition">
        Név kiegészítés: {{ gate.name_addition }}
      </div>

      <v-divider class="my-2" />

      <div v-if="gate.reader">
        Olvasó: {{ gate.reader?.name }}
      </div>
      <div>
        Relé:
        <span v-if="gate.relay">{{ gate.relay?.name }}</span>
        <span v-else>Nincs</span>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn
        text
        icon
        tile
        color="primary"
        class="ma-2 rounded-lg"
        @click="remoteOpen">
        <v-icon>mdi-door-open</v-icon>
      </v-btn>
      <v-spacer />
      <v-btn
        text
        icon
        tile
        color="primary"
        class="ma-2 rounded-lg"
        :to="{ name: toRouteName, params: { id: gate.element_id } }">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn
        text
        icon
        tile
        color="primary"
        class="ma-2 rounded-lg"
        @click="$emit('edit', gate)">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['barrier', 'door', 'turnstile'].includes(value);
      }
    },

    gate: {
      type: Object,
      default: null,
    },

    building: {
      type: Object,
      default: () => ({}),
    },

    buildingLevel: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    async remoteOpen() {
      this.$emit('remote-open', this.gate);
      const confirm = await this.$dialog.confirm({
        type: 'warning',
        text: `<b>${this.gate.name}</b> kinyitására készül! Nyitás után automatikusan visszazáródik.<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) {
        return;
      }

      try {
        const response = await this.$http.get(`remote-open/open/${this.gate.element_id}`);
        if (response.status === 'OK') {
          this.$dialog.notify.success('Nyitás parancs elküldve!');
          this.fetchGates();
        }
      } catch (e) {
        console.error(e);
      }
    },
  },

  computed: {
    toRouteName() {
      switch (this.type) {
        case 'barrier':
          return 'BarrierEditor';
        case 'door':
          return 'DoorEditor';
        case 'turnstile':
          return 'TurnstileEditor';
      }
    },
  },
};
</script>